import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMobile } from '@fortawesome/pro-solid-svg-icons';
import { faTable } from '@fortawesome/pro-solid-svg-icons';
import * as styles from './PreviewToggleButton.css';

type PreviewToggleButtonProps = {
  isPreviewVisible: boolean;
  onClick: () => void;
  testId?: string;
};

export const PreviewToggleButton = ({
  isPreviewVisible,
  onClick,
  testId,
}: PreviewToggleButtonProps) => {
  return (
    <div className={styles.container}>
      <button
        className={styles.iconButton({ selected: isPreviewVisible })}
        onClick={onClick}
        type="button"
        data-testid={testId}
        aria-label="Mobile preview"
      >
        <FontAwesomeIcon icon={faMobile} />
      </button>
      <button
        className={styles.iconButton({ selected: !isPreviewVisible })}
        onClick={onClick}
        type="button"
        aria-label="Grid view"
      >
        <FontAwesomeIcon icon={faTable} />
      </button>
    </div>
  );
};
